/* ------------------------- External Dependencies -------------------------- */
import { Text } from 'particles'
/* --------------------------- Styled Component ----------------------------- */
Text.defaultProps = {
  is: 'p',
  mb: 10,
}
export default Text


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Paragraph/index.js